import React, { useEffect } from "react";
import { FaCheckCircle, FaExclamationCircle } from "react-icons/fa";

const Notification = ({ type, message, onClose }) => {
  useEffect(() => {
    // Cierra automáticamente la notificación después de 3 segundos
    const timer = setTimeout(() => {
      onClose();
    }, 2000);

    return () => clearTimeout(timer); // Limpia el temporizador al desmontar
  }, [onClose]);

  const getIcon = () => {
    if (type === "success") return <FaCheckCircle className="text-green mr-2" />;
    if (type === "error") return <FaExclamationCircle className="text-red-500 mr-2" />;
    return null;
  };

  return (
    <div
      className="fixed top-5 right-5 flex items-center bg-white shadow-lg border-l-4 rounded-md p-4 z-[9999]"
      style={{ borderColor: type === "success" ? "green" : "red" }}
    >
      {getIcon()}
      <span className="text-black text-bold">{message}</span>
    </div>
  );
};

export default Notification;

